<accessible-by-keyboard
    (execute)="openTableConfigurationModal()"
    linkClass="wp-table--columns-selection"
    [linkTitle]="text.configureTable"
    [linkAriaLabel]="text.configureTable">
  <op-icon icon-classes="icon-button icon-small icon-settings"></op-icon>
</accessible-by-keyboard>
